import { SidebarProvider, useSidebar } from "../context/SidebarContext";
import { Outlet } from "react-router";
import AppHeader from "./AppHeader";
import Backdrop from "./Backdrop";
import AppSidebar from "./AppSidebar";

const LayoutContent: React.FC = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();

  return (
    <div className="min-h-screen xl:flex">
      <div>
        <AppSidebar />
        <Backdrop />
      </div>
      <div
        // min-w-0: a flex item will not shrink below its widest content, so
        // without it one wide table widened the whole page and pushed the
        // content under the sidebar, instead of scrolling inside its own box.
        // overflow-x-clip: anything ELSE that pokes past the right edge (a
        // chart tooltip, a menu, a wide card) must not make the page scroll
        // sideways either — the sidebar is fixed, so a sideways-scrolled page
        // slides the header and title under it. clip, not hidden: hidden
        // makes this a scroll container and the sticky header stops sticking.
        className={`min-w-0 overflow-x-clip flex-1 transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? "lg:ml-[290px]" : "lg:ml-[90px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
        <AppHeader />
        <div className="p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const AppLayout: React.FC = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default AppLayout;
